import { type ReactNode } from 'react';
import { useCountdown } from '@/hooks/use-countdown';
import { formatClosedAtRelative } from '@/utils/relative-date';
import type {
  RaceBonusEntry,
  RaceCycleType,
} from '../hooks/use-race-bonus-current';
import { compactCountdown } from '../utils/race-countdown';

const CYCLE_LABEL: Record<RaceCycleType, string> = {
  daily: 'Diario',
  weekly: 'Semanal',
  monthly: 'Mensual',
};

const SUFFIX = 'font-normal normal-case tracking-normal text-text-tertiary/40';

function Countdown({ to }: { to: string }): ReactNode {
  const cd = useCountdown(to);
  if (!cd || cd.expired) return null;
  return (
    <span className={`font-mono tabular-nums ${SUFFIX}`}>
      {' · '}
      {compactCountdown(cd)}
    </span>
  );
}

export function RaceCycleLabel({ race }: { race: RaceBonusEntry }): ReactNode {
  return (
    <p className="whitespace-nowrap text-[10px] font-medium uppercase leading-tight tracking-wider text-text-tertiary/70">
      {CYCLE_LABEL[race.cycle_type]}
      <span className={SUFFIX}>
        {' · meta '}
        {race.threshold}
        {' creadores'}
      </span>
      {race.winner ? (
        <span className={SUFFIX}>
          {' · Cerrado '}
          {formatClosedAtRelative(race.winner.achieved_at)}
        </span>
      ) : (
        <Countdown to={race.cycle_end_iso} />
      )}
    </p>
  );
}
